<div class="card card-custom">
  <div *ngIf="loading$|async" class="card-body-progress card-body-progress-overlay">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">
        {{title$|async}}
      </h3>
      <!-- TODO: Incase tooltip is added -->
      <!-- <mat-icon color="primary" 
        class="cursor-pointer ml-1" 
        [ngbPopover]="''"
        [popoverTitle]="''"
        (click)="$event.stopPropagation()">
        help
      </mat-icon> -->
    </div>

    <div class="card-toolbar">
      <span [matTooltip]="'Duplicate'">
        <button class="btn btn-icon btn-sm btn-success mr-2 p-1" style="width: 80px;" (click)="onSubmit()">
          Validate
        </button>
      </span>
      <button class="btn btn-icon btn-sm btn-light-warning p-1" (click)="onClose()">
        <i class="ki ki-close icon-nm"></i>
      </button>
    </div>
  </div>

  <div class="form" [formGroup]="form">
    <div class="card-body">
      <mat-dialog-content>
        <div class="form-group kt-form-group">
          <div class="row">
            <div class="col-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <input matInput formControlName="name" placeholder="Assignment ID" />
                <mat-error>
                  Assignment ID is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <mat-select formControlName="project_manager_id" placeholder="Project Manager">
                  <ng-container *ngFor="let option of (users$|async)">
                    <mat-option [value]="option.value">
                      {{option.label}}
                    </mat-option>
                  </ng-container>
                </mat-select>
                <mat-error>
                  Project Manager is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <mat-select formControlName="agency_id" placeholder="Agency">
                  <ng-container *ngFor="let option of (agencies$|async)">
                    <mat-option [value]="option.value">
                      {{option.label}}
                    </mat-option>
                  </ng-container>
                </mat-select>
                <mat-error>
                  Agency is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <h5 class="my-3 text-mad">
          Choose which Terms of Engagement to include
        </h5>
        <hr class="active" />
        <div class="form-group kt-form-group">
          <div class="row">
            <div class="col-6" *ngFor="let option of (toes$|async)">
              <mat-checkbox class="toe_name" [checked]="option.checked" (change)="onToeSelected($event, option)">
                {{ option.name }}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>
  </div>
</div>